const routes = [
    {
        path: "/appeal/to/the/grade/change/appeal/form",
        component: () => import("../pages/Form.vue"),
        meta: {
            isAuthenticated: true,
        },
    },
];

export default routes;
